module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('cell', {
    attrs: {
      "value-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.cuIndex) + "."), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.choice.subjectName)
    }
  }), _vm._v(" "), _c('span', [(_vm.choice.score !== '' && _vm.choice.score !== undefined && _vm.choice.score !== 0) ? _c('span', {}, [_vm._v("(" + _vm._s(_vm.choice.score) + "分)")]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "choice-option"
  }, [_c('checker', {
    ref: _vm.choice.id,
    attrs: {
      "align": "left",
      "default-item-class": "option-item",
      "selected-item-class": "option-item-selected"
    },
    on: {
      "on-change": _vm.toggleOption
    },
    model: {
      value: (_vm.anwser),
      callback: function($$v) {
        _vm.anwser = $$v
      },
      expression: "anwser"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.optionContent))])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9db806","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/CheckChoice/index.vue
// module id = mZKW
// module chunks = 6